<template>
  <div id="header-dashboard">
    <div class="logo">
      <router-link to="/console/main">
        <div
          v-if="FACE === 'MASTEK'"
          id="logo"
          class="center-element center-text"
        >
          <img
            src="../assets/mastek_small@2x.png"
            srcset="
              ../assets/mastek_small@1x.png 1x,
              ../assets/mastek_small@2x.png 2x
            "
          />
        </div>
        <div v-else>
          <img
            src="../assets/machinecore_logo_small_final@2x.png"
            srcset="
              ../assets/machinecore_logo_small_final@1x.png 1x,
              ../assets/machinecore_logo_small_final@2x.png 2x
            "
          />
        </div>
      </router-link>
    </div>
    <div class="logout">
      <span><router-link to="/console/dashboard">Home</router-link> | </span>
      <router-link to="/console/account">Account</router-link> |
      <a href="#" @click.prevent="logout">Logout</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderDashboard",
  data() {
    return {
      msg: "Welcome to Feedback AI",
      FACE: process.env.VUE_APP_FACE
    };
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#header-dashboard {
  lost-utility: clearfix;
  border-bottom: 2px solid black;
  background-color: white;
}
#header-dashboard div {
  lost-column: 1/2;
  height: 50px;
}
.logo {
  lost-align: left;
}
.logo img {
  max-width: 200px;
  text-align: left;
  margin-left: 15px;
  padding-top: 5px;
}
.logout {
  height: 50px;
  line-height: 50px;
  white-space: nowrap;
  text-align: right;
  padding-right: 20px;
}
@media (max-width: 550px) {
  .logout span {
    display: none;
  }
}
</style>
